import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Header } from './components/Header';
import { Footer } from './components/Footer';
import { PromoBanner } from './components/PromoBanner';
import { useScreenInit } from './useScreenInit';
import { Home } from './pages/Home';
// We will import the service pages here once created
import { Haircuts } from './pages/Haircuts';
import { Coloring } from './pages/Coloring';
import { Perms } from './pages/Perms';
import { Styling } from './pages/Styling';
import { Nails } from './pages/Nails';
import { Piercing } from './pages/Piercing';
import { CoursesPage } from './pages/CoursesPage';
export function App() {
  useScreenInit();
  useEffect(() => {
    document.title = 'Сайт створено';
  }, []);
  return <BrowserRouter data-id="element-0">
      <div className="font-sans text-ink bg-white selection:bg-ink selection:text-white" data-id="element-1">
        <Header data-id="element-2" />
        <Routes data-id="element-3">
          <Route path="/" element={<Home data-id="element-5" />} data-id="element-4" />
          <Route path="/services/haircuts" element={<Haircuts data-id="element-7" />} data-id="element-6" />
          <Route path="/services/coloring" element={<Coloring data-id="element-9" />} data-id="element-8" />
          <Route path="/services/perms" element={<Perms data-id="element-11" />} data-id="element-10" />
          <Route path="/services/styling" element={<Styling data-id="element-13" />} data-id="element-12" />
          <Route path="/services/nails" element={<Nails data-id="element-15" />} data-id="element-14" />
          <Route path="/services/piercing" element={<Piercing data-id="element-17" />} data-id="element-16" />
          <Route path="/courses" element={<CoursesPage data-id="element-19" />} data-id="element-18" />
        </Routes>
        <Footer data-id="element-20" />
        <PromoBanner data-id="element-21" />
      </div>
    </BrowserRouter>;
}